/** Source of truth: server/constants/time.js */

// ── Activity Tracking ──
export const HEARTBEAT_INTERVAL_MS = 5_000;
export const VISIBILITY_DEBOUNCE_MS = 500;
export const IDLE_CHECK_INTERVAL_MS = 10_000;

// ── WebSocket ──
export const WS_CONNECT_TIMEOUT_MS = 20_000;
export const WS_PING_INTERVAL_MS = 25_000;
export const WS_RECONNECT_DELAY_MS = 30_000;
export const WS_MAX_RECONNECT_ATTEMPTS = 5;
export const WS_SYSTEM_SETTLE_MS = 1_000;

// ── HTTP / API ──
export const API_REQUEST_TIMEOUT_MS = 30_000;
export const API_SAFETY_TIMEOUT_MS = 45_000;
export const API_RETRY_DELAY_MS = 2_000;
export const DEFAULT_CACHE_TIME_MS = 30_000;

// ── Permission cache ──
export const PERMISSION_CLIENT_CACHE_MS = 5 * 60 * 1000;

// ── Cache durations (seconds) ──
export const CACHE_DURATIONS = {
  machineState: 60,
  sixs: 300,
  analytics: 60,
  safetyAreas: 300,
  safetyIncidents: 60,
  safetyInspections: 300,
  safetyAnalytics: 60,
  pmAreas: 300,
  pmSchedule: 60,
  pmCompletions: 60,
  pmAnalytics: 300,
  default: 60,
};

// ── UI delays ──
export const NOTIFICATION_DELAY_MS = 1_000;
export const FORCE_REFLOW_DELAY_MS = 100;
